import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "..";
import { calculateData } from "@/pages/household/UP/up-utils";
import { uqActions } from "./uq-slice";
import { UPSettings } from "@/types/types";

export const CalculateGrid = (row: number, newGrid?: any, settings?: UPSettings) => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    const reduxSettings = getState().uq.settings;
    const gridSet = getState().uq.gridSet;
    const household = getState().household.household;
    const settingsToUse = settings ?? reduxSettings;

    const newDataSet = await calculateData(
      settingsToUse,
      household,
      newGrid ? newGrid : gridSet,
      row
    );

    dispatch(uqActions.setGrid(newDataSet));
    if (newGrid && newGrid.length > 1) dispatch(uqActions.setIsModified(true));

    return newDataSet;
  };
};
